import englishWords from "./languages/english_lang";
import indonesiaWords from "./languages/indonesia_lang";

const languages = {
    'english' : englishWords,
    'indonesia': indonesiaWords
}

export default languages;